export default {
  getUrlExtension (url) {
    let ext = url.split(/[#?]/)[0].split('.').pop().trim()
    ext = ext.toLowerCase()
    return ext
  }
}
